import { AnyAction, ListenerEffectAPI, ThunkDispatch } from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { getWebGames } from '../thunks/get-web-games.thunk';
import { WebGameHeaderFiltersAndPaginationModel } from '../thunks/models/web-game-header-filters-and-pagination.model';

export const WebGamesFiltersListenerEffect = (
  action: AnyAction,
  api: ListenerEffectAPI<
    AppRootState,
    ThunkDispatch<AppRootState, undefined, AnyAction>,
    unknown
  >
): void => {
  const filters: Partial<WebGameHeaderFiltersAndPaginationModel> =
    api.getState().webGames.filters;
  api.dispatch(getWebGames(filters));
};
